import type { MegaMillionsParticipation } from '../types';
import { registerLottery } from './extras';

function isMegaplierEnabled(participation: MegaMillionsParticipation) {
  return !!participation.multiplierEnabled;
}

registerLottery('megaMillions', {
  extractLineInfo: ({ participation, lineNumber }) => {
    if (!isMegaplierEnabled(participation as MegaMillionsParticipation)) {
      return null;
    }

    const multiplier = (participation as MegaMillionsParticipation).multipliersPerLine?.[lineNumber];

    if (multiplier) {
      return {
        translationKey: 'multiplier_value',
        translationParams: { value: multiplier },
      };
    }

    return {
      translationKey: 'multiplier_pending',
    };
  },
  extractPurchaseSummaryItems: ({ participation }) => {
    if (!participation || isMegaplierEnabled(participation as MegaMillionsParticipation)) {
      return [];
    }

    return [{ id: 'megaplier', translationKey: 'ticket_details.your_numbers_section.extras.megaplier' }];
  },
});
